import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import './styles/index.css';
import App from './App';
import SiteGate from './components/SiteGate';
import { NotificationProvider } from '@mysimpledb/shared/context/NotificationContext';
import { initGlobalTokenFromStorage } from '@mysimpledb/shared/utils/tokenStore';
import { BrowserRouter } from 'react-router-dom';
import { setRuntimeEnvVar } from '@mysimpledb/shared/config/runtimeEnv';
import { VaultProvider } from '@mysimpledb/shared/context/VaultContext';
import { registerVaultCryptoWeb } from './utils/crypto/registerVaultCryptoWeb';

registerVaultCryptoWeb();

setRuntimeEnvVar('API_URL', process.env.REACT_APP_API_URL);
initGlobalTokenFromStorage();

const ENABLE_SITE_GATE =
  String(process.env.REACT_APP_ENABLE_SITE_GATE || 'true').toLowerCase() ===
  'true';

const appTree = (
  <BrowserRouter>
    <NotificationProvider>
      <VaultProvider>
        {ENABLE_SITE_GATE ? (
          <SiteGate>
            <App />
          </SiteGate>
        ) : (
          <App />
        )}
      </VaultProvider>
    </NotificationProvider>
  </BrowserRouter>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode>{appTree}</React.StrictMode>);
